import { memoize } from 'lodash';
import React, { useMemo } from 'react';

export enum BRANDS {
  AV = 'AV',
  ECOSU = 'ECOSU',
  WODOMAT = 'wodomat'
}

const BRAND_KEY = 'aw:brand';

export const getBrand = memoize((): BRANDS => {
  const url = new URL(window.location.href);
  const brand = url.searchParams.get('brand') as BRANDS | undefined;
  try {
    const savedBrand = localStorage.getItem(BRAND_KEY);

    if (brand && Object.values(BRANDS).includes(brand)) {
      localStorage.setItem(BRAND_KEY, brand);
      return brand;
    }
    if (brand && !(brand in BRANDS)) {
      localStorage.removeItem(BRAND_KEY);
    } else if (!brand && savedBrand) {
      return savedBrand as BRANDS;
    }
  } catch {
    //
  }

  switch (true) {
    case /ecosu/.test(window.location.hostname):
      return BRANDS.ECOSU;
    case /wodomat\.pl/.test(window.location.hostname):
      return BRANDS.WODOMAT;
    default:
      return BRANDS.AV;
  }
});

export function useBrand(): BRANDS {
  return useMemo(getBrand, []);
}

export function withBrand<P>(Component: React.ComponentType<P>) {
  function Wrapped(props: P) {
    const brand = useBrand();
    return <Component {...props} brand={brand} />;
  }
  Wrapped.displayName = `withBrand(${Component.displayName || Component.name})`;
  return Wrapped;
}
